var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Report from '../ScoreReport/Report';
import Evaluate from './Evaluate';
import Graph from './Graph';
import { useAiReportStore } from "../../../../store/ai-report/global-store";
import { Box, Paper, Stack } from 'fbm-ui/lib/mui';
var Index = function () {
    var _a = useAiReportStore(function (store) { return [store.reportResult, store.operableButtons]; }), reportResult = _a.reportResult, showAiDimension = _a.showAiDimension, canEditAiDimension = _a.canEditAiDimension;
    var _b = (reportResult || {}).collection, collection = _b === void 0 ? [] : _b;
    var items = collection.map(function (item) { return ({
        name: item.name,
        score: item.avgScore,
    }); });
    if (!showAiDimension)
        return null;
    return (_jsx(Box, __assign({ id: "report-evaluate", px: 2, width: 1 }, { children: _jsx(Box, __assign({ component: Paper, elevation: 0, bgcolor: "transparent", mb: 3 }, { children: _jsxs(Stack, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Box, __assign({ mt: 2, flex: 1 }, { children: _jsx(Graph, { items: items }) })), _jsx(Report, {})] })), (reportResult === null || reportResult === void 0 ? void 0 : reportResult.workplaceEvaluation) && (_jsx(Evaluate, { token: "", canEdit: canEditAiDimension, evaluations: reportResult === null || reportResult === void 0 ? void 0 : reportResult.workplaceEvaluation, title: "\u7EFC\u5408\u8BC4\u4EF7", field: "evaluations", mode: "show" }))] }) })) })));
};
export default Index;
